const html = require("./html/requestQuoteView.html");
import {setElementsFromScope, swapClasses, insertValAndManageFocus, show, hide, handleDisplayForV2, toggleClassViaBool} from "../../../utilities/selectorHelpers";
import {isPresent} from "../../../utilities/general";
import {unbindAll, extractElements} from "../../../utilities/viewHelpers";
import _ from "underscore";
import $ from "jquery";
import AsnStore from "../../../stores/AsnStore";
import QuoteStore from "../../../stores/QuoteStore";
import AsnShippingPalletStore from "../../../stores/AsnShippingPalletStore";
import AsnDetailStore from "../../../stores/AsnDetailStore";
import AvailableQuotesListView from "./AvailableQuotesListView";

const elementsMap = {
  requestQuoteBtn: ".request-quote-btn",
  requestQuoteNotice: ".request-quote-notice",
  requestQuoteFailedNotice: ".request-quote-notice-failed",
  requestQuoteOuter: ".request-quote-outer",
  loaderOuter: ".loader-outer",
  requestQuoteSpecialNotice: ".request-quote-special-notice",
  requestQuoteRemovedNotice: ".request-quote-removed-notice",
  requestQuoteNotClickedNotice: ".shipping-tab-request-quote-not-clicked-error-message",
  requestQuoteNoSelectedQuote: ".shipping-tab-request-quote-no-selected-quote-error-message",
  quotesEntryPoint: ".quotes-entry-point"
}
 
export default function RequestQuoteView(_unused, {
  getAsn,
  onAsnFieldsChange,
  csrEmailUrl,
  onRequestQuoteClicked,
  isPallet,
  didAttemptToNavigateAwayFromCurrentForm
}){
  const self = this;
  self._element = $();
  const els = {};
  let asnDetailRowViews = [];

  self.init = function(){
    render();
  }

  function setElements(){
    setElementsFromScope(els, elementsMap, self._element);
  }

  function setWidgets(){
    renderAvailableQuotesListView();
  }

  self.getElement = function(){
    return self._element;
  }

  function update(){
    updateSelf();
  }

  function updateSelf(){
    updateDisplay();
    updateRequestQuoteBtn();
  }

  function bindStores(){
    AsnStore.bindListener("asns:shipping_method_changed", updateSelf);
    AsnStore.bindListener("asns:change", updateSelf);
    AsnDetailStore.bindListener("asn_details:change", updateSelf);
    QuoteStore.bindListener("quotes:changed", updateSelf);
  }

  self.unbindListeners = function(){
    AsnStore.unbindListener("asns:shipping_method_changed", updateSelf);
    AsnStore.unbindListener("asns:change", updateSelf);
    AsnDetailStore.unbindListener("asn_details:change", updateSelf);
    QuoteStore.unbindListener("quotes:changed", updateSelf);
  }

  function bindElements(){
    els.requestQuoteBtn.on("click", onRequestQuoteClickCb);
  }

  function onRequestQuoteClickCb(e){
    e.preventDefault();
    if(canRequestQuote()){
      onRequestQuoteClicked(e);
    }
  }

  function updateRequestQuoteBtn(){
    const canReqQuote = canRequestQuote();
    toggleClassViaBool(els.requestQuoteBtn, "disabled", !canReqQuote);
  }

  function canRequestQuote(){
    const asn = getAsn();

    // if we are currently fetching quotes,
    // obviously we can't beginning fetching another
    if(isFetchingQuotes(asn)){
      return false;
    }

   
   /* if(!isPallet(asn)){
      return true;
    }*/
    if(!isPallet(asn)){
      const freightShipping = hasFreigthSelected(getAsn());
      if(isPresent(freightShipping)){
        if(freightShipping && !isPresent(asn.pickupDate)){
          return false;
        }
      }  
    }
    
  
    // null or not there
    // const isNew = AsnStore.statusIsNew(asn);
    // "in progress" is saved but not submitted
    // const isInProgress = AsnStore.isInProgress(asn);
    // status is not null and not inprogress;
    return (
      AbilityStore.ask("canEditGtlAsn") &&
      isPickupTimeRangeValid(asn) &&
      isPresent(asn.pickupDate) &&
      AsnStore.hasAllPickupTimeFields(asn) &&
      areDimensionsAndWeightValid()
    );
  }

  function areDimensionsAndWeightValid(){
    const asn = getAsn();
     if(!isPallet(asn)){
      const freightShipping = hasFreigthSelected(asn);
      if(isPresent(freightShipping)){
        if(freightShipping){
          return AsnStore.allAsnShippingPalletsHaveDimensionsAndWeight(asn);
        }
      }  
    }else{
      return AsnStore.allAsnDetailsHaveDimensionsAndWeight(asn);
    }
    
  }

  function isPickupTimeRangeValid(asn){
    return AsnStore.isPickupTimeRangeValid(asn);
  }

  function updateDisplay(){
    const asn = getAsn();
    const isReqQuotes = isFetchingQuotes(asn);
    const quoteRequestSuccess = didQuoteRequestSucceed(asn);
    const quoteRequestFail = didAsnRequestQuoteFail(asn);
    const isPlt = isPallet(asn);
    const availableQuotes = AsnStore.getAvailableAndSelectedQuotesForAsn(asn);
    const specialQuote = isQuoteForAsnSpecial(asn);
    const didReqQuotes = didRequestQuotes(asn);
    const hasSelQuote = hasSelectedQuote(asn);
    const attemptedTraversalPassedShippingTab = alreadyAttempted(asn, "attemptedTraversalPassedShippingTab");
    const showQRemovedMessage = shouldShowQuotesRemovedBecauseInfoChangedMessage(asn);
    const hasAsnShippingPalletsData = AsnShippingPalletStore.getAllAsnShippingPallets();
    let hasAsnShippingPallets = false;
    if(!$.isEmptyObject(hasAsnShippingPalletsData)){
      hasAsnShippingPallets = true;
    }
    handleDisplayForV2(els.quotesEntryPoint, (!isReqQuotes && !!availableQuotes.length));

    handleDisplayForV2(els.loaderOuter, isReqQuotes);
    handleDisplayForV2(els.requestQuoteNotice, (!isPlt && quoteRequestSuccess && !hasAsnShippingPallets));
    handleDisplayForV2(els.requestQuoteFailedNotice, quoteRequestFail);
    handleDisplayForV2(els.requestQuoteSpecialNotice, ((isPlt || hasAsnShippingPallets) && specialQuote));
    handleDisplayForV2(els.requestQuoteRemovedNotice, ((isPlt || hasAsnShippingPallets) && showQRemovedMessage));

    handleDisplayForV2(els.requestQuoteNotClickedNotice, ((isPlt || hasAsnShippingPallets) && !showQRemovedMessage && !isReqQuotes && !didReqQuotes && !hasSelQuote && attemptedTraversalPassedShippingTab && !quoteRequestFail && !specialQuote));
    // make sure Request Quote Button WAS clicked before showing error regarding not making a selection
    handleDisplayForV2(els.requestQuoteNoSelectedQuote, ((isPlt || hasAsnShippingPallets) && !showQRemovedMessage && !isReqQuotes && didReqQuotes && attemptedTraversalPassedShippingTab && !hasSelQuote && !quoteRequestFail && !specialQuote));
  }


  function renderAvailableQuotesListView(){
    const availableQuotesListView = new AvailableQuotesListView(null, {
      getAsn,
      onAsnFieldsChange,
      isPallet
    })
    availableQuotesListView.init();
    els.quotesEntryPoint.html(availableQuotesListView.getElement());
  }

  function isFetchingQuotes(asn){
    return asn.isFetchingQuotes;
  }

  function areQuotesInvalidated(asn){
    return AsnStore.areQuotesInvalid(asn);
  }


  function didQuoteRequestSucceed(asn){
    return AsnStore.requestQuoteSucceeded(asn);
  }

  function didAsnRequestQuoteFail(asn){
    return AsnStore.requestQuoteFailed(asn);
  }

  function isQuoteForAsnSpecial(asn){
    return AsnStore.hasSpecialQuote(asn);
  }

  function hasSelectedQuote(asn){
    return AsnStore.hasSelectedQuote(asn);
  }

  function didRequestQuotes(asn){
    return AsnStore.didRequestQuotes(asn);
  }

  function shouldShowQuotesRemovedBecauseInfoChangedMessage(asn){
    return AsnStore.shouldShowQuotesRemovedBecauseInfoChangedMessage(asn);
  }

  function alreadyAttempted(asn, key){
    return !!asn[key];
  }


  function render(){
    self._element = $(html);
    setElements();
    setWidgets();
    update();
    bindElements();
    bindStores();
  }

  function hasFreigthSelected(asn){
    return AsnStore.hasFreigthSelected(asn.id);
  }

}


// WEBPACK FOOTER //
// ./src/pages/asns/ShippingTab/RequestQuoteView.js